import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgMobile24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Mobile",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.827 2H8.172C6.974 2 6 2.992 6 4.21v15.58C6 21.009 6.975 22 8.172 22h7.655C17.025 22 18 21.008 18 19.79V4.21C18 2.992 17.025 2 15.827 2M7.474 7.167h9.052V15.5H7.474zM8.172 3.5h7.655c.385 0 .699.319.699.71v1.456H7.474V4.21c0-.391.314-.71.698-.71m7.655 17H8.172a.705.705 0 0 1-.698-.71V17h9.052v2.79c0 .391-.314.71-.699.71"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.527 18.29c-.27-.28-.78-.28-1.06 0a.78.78 0 0 0-.22.53c0 .19.08.39.22.53s.34.22.53.22c.2 0 .4-.08.53-.22.14-.14.22-.34.22-.53 0-.1-.02-.2-.05-.29a.8.8 0 0 0-.17-.24"
}));

export { SvgMobile24 as default };
//# sourceMappingURL=Mobile24.js.map
